"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AbstractSnapRestriction_id, _AbstractSnapRestriction_parentNode, _AbstractSnapRestriction_viewport, _AbstractSnapRestriction_visualizationNode, _AbstractSnapRestriction_showVisualization;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractSnapRestriction = void 0;
const viewer_rendering_engine_rendering_engine_threejs_1 = require("@shapediver/viewer.rendering-engine.rendering-engine-threejs");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const THREE = __importStar(require("three"));
class AbstractSnapRestriction {
    // #endregion Properties (10)
    // #region Constructors (1)
    constructor(viewport, parentNode, id) {
        // #region Properties (10)
        _AbstractSnapRestriction_id.set(this, void 0);
        _AbstractSnapRestriction_parentNode.set(this, void 0);
        _AbstractSnapRestriction_viewport.set(this, void 0);
        _AbstractSnapRestriction_visualizationNode.set(this, new viewer_shared_node_tree_1.TreeNode("RestrictionVisualizationNode"));
        _AbstractSnapRestriction_showVisualization.set(this, false);
        this._active = false;
        this._enabled = true;
        this._enabledEditable = true;
        this._priority = 0;
        __classPrivateFieldSet(this, _AbstractSnapRestriction_parentNode, parentNode, "f");
        __classPrivateFieldSet(this, _AbstractSnapRestriction_viewport, viewport, "f");
        __classPrivateFieldSet(this, _AbstractSnapRestriction_id, id, "f");
        this.createGridHelperObject();
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (11)
    get active() {
        return this._active;
    }
    set active(value) {
        this._active = value;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabledEditable === false)
            return;
        this._enabled = value;
        this.visibilityChanged(this._object3D.visible);
    }
    get enabledEditable() {
        return this._enabledEditable;
    }
    set enabledEditable(value) {
        this._enabledEditable = value;
    }
    get id() {
        return __classPrivateFieldGet(this, _AbstractSnapRestriction_id, "f");
    }
    get priority() {
        return this._priority;
    }
    set priority(value) {
        this._priority = value;
    }
    get showVisualization() {
        return __classPrivateFieldGet(this, _AbstractSnapRestriction_showVisualization, "f");
    }
    set showVisualization(value) {
        __classPrivateFieldSet(this, _AbstractSnapRestriction_showVisualization, value, "f");
        this._object3D.visible = value;
        this.visibilityChanged(this._object3D.visible);
    }
    // #endregion Public Getters And Setters (11)
    // #region Public Methods (1)
    removeVisualization() {
        __classPrivateFieldGet(this, _AbstractSnapRestriction_parentNode, "f").removeChild(__classPrivateFieldGet(this, _AbstractSnapRestriction_visualizationNode, "f"));
        __classPrivateFieldGet(this, _AbstractSnapRestriction_parentNode, "f").updateVersion(false, false);
        __classPrivateFieldGet(this, _AbstractSnapRestriction_viewport, "f").updateNode(__classPrivateFieldGet(this, _AbstractSnapRestriction_parentNode, "f"));
    }
    // #endregion Protected Abstract Methods (1)
    // #region Private Methods (1)
    createGridHelperObject() {
        this._object3D = new THREE.Object3D();
        this._object3D.visible = false;
        const node = new viewer_shared_node_tree_1.TreeNode("ThreeJsDataNode");
        const data = new viewer_rendering_engine_rendering_engine_threejs_1.ThreejsData(this._object3D);
        node.addData(data);
        __classPrivateFieldGet(this, _AbstractSnapRestriction_visualizationNode, "f").addChild(node);
        __classPrivateFieldGet(this, _AbstractSnapRestriction_visualizationNode, "f").updateVersion();
        __classPrivateFieldGet(this, _AbstractSnapRestriction_parentNode, "f").addChild(__classPrivateFieldGet(this, _AbstractSnapRestriction_visualizationNode, "f"));
        __classPrivateFieldGet(this, _AbstractSnapRestriction_parentNode, "f").updateVersion(false, false);
        __classPrivateFieldGet(this, _AbstractSnapRestriction_viewport, "f").updateNode(__classPrivateFieldGet(this, _AbstractSnapRestriction_parentNode, "f"));
    }
}
exports.AbstractSnapRestriction = AbstractSnapRestriction;
_AbstractSnapRestriction_id = new WeakMap(), _AbstractSnapRestriction_parentNode = new WeakMap(), _AbstractSnapRestriction_viewport = new WeakMap(), _AbstractSnapRestriction_visualizationNode = new WeakMap(), _AbstractSnapRestriction_showVisualization = new WeakMap();
//# sourceMappingURL=AbstractSnapRestriction.js.map